import clsx from 'clsx';
import { Pencil } from 'react-bootstrap-icons';

import { AddIcon } from '@repo/ui/assets/icons/AddIcon';
import { TrashIcon } from '@repo/ui/assets/icons/TrashIcon';

import './ActionIconWrapper.scss';

type Action = 'add' | 'delete' | 'edit';

const iconMap = {
  add: AddIcon,
  delete: TrashIcon,
  edit: Pencil,
};

interface ActionIconWrapperProps {
  action: Action;
  className?: string;
}

export function ActionIconWrapper({ action, className }: ActionIconWrapperProps) {
  const IconComponent = iconMap[action];
  const combinedClassName = clsx('ActionIconWrapper', className);

  return (
    <div className={combinedClassName}>
      <IconComponent />
    </div>
  );
}
